/* YoshMarket — additive JS layer. Vanilla ES6+, no deps, loaded with defer.
   Responsibilities:
     - Reveal sticky ATC after primary form scrolls out of view
     - Forward click from sticky CTA → real product form submit button
     - Debug helper: ?ym-debug=sticky forces the bar visible everywhere
   v1.0.2 — adds scroll fallback + debug param + z-index bump (via CSS).
*/
(function () {
  'use strict';

  /* -------- Sticky add-to-cart on mobile -------- */
  function initStickyATC() {
    var bar = document.querySelector('[data-ym-sticky-atc]');
    if (!bar) return;

    // Debug helper: ?ym-debug=sticky forces the bar visible on all viewports.
    // Useful for testing visibility without needing a real mobile device.
    if (/[?&]ym-debug=sticky/.test(location.search)) {
      bar.style.display = 'block';
      bar.classList.add('is-visible');
      return;
    }

    var refForm =
      document.querySelector('product-form') ||
      document.querySelector('[data-ym-atc-ref]') ||
      document.querySelector('form[action*="/cart/add"]');
    if (!refForm) return;

    function show() { bar.classList.add('is-visible'); }
    function hide() { bar.classList.remove('is-visible'); }

    // Primary mechanism: IntersectionObserver on the main product form.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) hide();
          else if (entry.boundingClientRect.top < 0) show();
        });
      }, { threshold: 0, rootMargin: '0px 0px -40% 0px' });
      io.observe(refForm);
    }

    // Fallback: scroll listener. Handles edge cases where IO doesn't fire
    // (suspended tabs, certain embedded contexts) and keeps state consistent.
    var ticking = false;
    function checkScroll() {
      var rect = refForm.getBoundingClientRect();
      if (rect.bottom < 0) show();
      else if (rect.top > window.innerHeight * 0.5) hide();
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          checkScroll();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
    checkScroll();
  }

  /* -------- Sticky CTA click → forward to real form submit -------- */
  function handleStickySubmit(e) {
    var trigger = e.target.closest('[data-ym-sticky-submit]');
    if (!trigger || trigger.disabled) return;
    e.preventDefault();
    var form =
      document.querySelector('product-form form') ||
      document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var submitBtn = form.querySelector('[type="submit"]:not([disabled])');
    if (submitBtn) submitBtn.click();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyATC);
  } else {
    initStickyATC();
  }
  document.addEventListener('click', handleStickySubmit);
})();

/* YM — "Complete ta collection" : cartes complementaires maison, horizontales */
(function () {
  'use strict';
  function accBody() {
    var body = null;
    document.querySelectorAll('[data-ym-accordions] .ym-acc').forEach(function (acc) {
      var t = acc.querySelector('.ym-acc__title');
      if (t && t.textContent.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').indexOf('complete') !== -1) {
        body = acc.querySelector('.ym-acc__body');
      }
    });
    return body;
  }
  function money(c) {
    try { return (c / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' }); }
    catch (e) { return (c / 100).toFixed(2) + ' €'; }
  }
  function card(p) {
    var img = typeof p.featured_image === 'string' ? p.featured_image : (p.images && p.images[0]) || '';
    var price = '<span class="ym-cross__now">' + money(p.price) + '</span>';
    if (p.compare_at_price && p.compare_at_price > p.price) {
      price = '<span class="ym-cross__was">' + money(p.compare_at_price) + '</span> ' + price;
    }
    return '<a class="ym-cross__card" href="' + p.url + '">' +
      (img ? '<span class="ym-cross__img"><img loading="lazy" src="' + img + '" alt=""></span>' : '') +
      '<span class="ym-cross__title">' + p.title + '</span>' +
      '<span class="ym-cross__price">' + price + '</span></a>';
  }
  function run(body) {
    if (body.querySelector('.ym-cross')) return;
    var id; try { id = ShopifyAnalytics.meta.product.id; } catch (e) { return; }
    if (!id) return;
    fetch('/recommendations/products.json?product_id=' + id + '&intent=complementary&limit=6')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var ps = j.products || []; if (!ps.length) return;
        var wrap = document.createElement('div');
        wrap.className = 'ym-cross';
        wrap.innerHTML = ps.map(card).join('');
        body.appendChild(wrap);
        var native = document.querySelector('.complementary-products');
        if (native) { native.style.display = 'none'; }
      }).catch(function () {});
  }
  function start() {
    var n = 0;
    var iv = setInterval(function () {
      var body = accBody();
      if (body) { clearInterval(iv); run(body); }
      else if (++n > 60) clearInterval(iv);
    }, 150);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();